import APIClient from '@/shared/http/clients/api'

const resourceName = 'observacao'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetByCardId = (cardId, config = {}) => APIClient.get(`${APICore}/${resourceName}/?cardId=${cardId}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (boardColumnId = {}, situacao = 1, filter = '', limit, index, sortValue = 'posicao', config = {}) => APIClient.get(`${APICore}/${resourceName}/?boardColumnId=${boardColumnId}&situacao=${situacao}${filter != null ? filter : ''}&page=${index}&size=${limit}&sort=${sortValue}`, config)

const ObservationRepository = {
  GetAll,
  GetById,
  GetByCardId,
  Create,
  Update,
  Delete,
  Search
}

export default ObservationRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/crm/observation.js